<template>
  <div class="timeline-viewport relative min-h-full w-full flex-none">
    <div class="timeline-viewport__track">
      <div class="timeline-viewport__axis timeline-viewport__axis--vertical bg-slate-300" aria-hidden="true" />
      <div class="timeline-viewport__axis timeline-viewport__axis--horizontal bg-slate-300" aria-hidden="true" />

      <ol class="timeline-viewport__periods" aria-label="Timeline periods">
        <timeline-period
          v-for="period in periods"
          :key="period.id"
          :ref="element => setPeriodRef(period.id, element)"
          :period="period"
          :show-actions="showActions"
          @select="$emit('select', $event)"
          @action="$emit('action', $event)"
        />
      </ol>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    periods: {
      type: Array,
      default: () => []
    },
    showActions: Boolean
  });

  defineEmits(['select', 'action']);

  const periodElements = new Map();

  function setPeriodRef(periodId, element) {
    if (element) {
      periodElements.set(periodId, element);
    } else {
      periodElements.delete(periodId);
    }
  }

  function focusPeriod(periodId) {
    const period = props.periods.find(item => item.id === periodId);
    periodElements.get(period?.id)?.focus({preventScroll: true});
  }

  defineExpose({focusPeriod});
</script>

<style scoped>
  .timeline-viewport {
    --timeline-accent-color: theme('colors.heroblue.500');
    --timeline-track-height: 640px;
    --timeline-period-width: 100%;
    --timeline-vertical-period-step: 160px;
    --timeline-card-width: min(calc(50% - 28px), 340px);
    --timeline-card-height: auto;
    --timeline-axis-position: 50%;
    --timeline-connector-gap: 28px;
  }

  .timeline-viewport__track {
    position: relative;
    min-width: 100%;
    padding: 1rem 0;
  }

  .timeline-viewport__periods {
    position: relative;
  }

  .timeline-viewport__axis {
    position: absolute;
  }

  .timeline-viewport__axis--vertical {
    top: 0;
    bottom: 0;
    left: 50%;
    width: 2px;
    transform: translateX(-50%);
  }

  .timeline-viewport__axis--horizontal {
    display: none;
  }

  @media (min-width: 480px) {
    .timeline-viewport {
      --timeline-vertical-period-step: 200px;
    }
  }

  @media (min-width: 768px) {
    .timeline-viewport {
      --timeline-vertical-period-step: 250px;
    }
  }

  @media (min-width: 1200px) {
    .timeline-viewport {
      --timeline-track-height: 670px;
      --timeline-period-width: 250px;
      --timeline-card-width: 340px;
      --timeline-card-height: 255px;
      --timeline-axis-position: 50%;
    }

    .timeline-viewport__track {
      width: max-content;
      height: var(--timeline-track-height);
      padding: 0 3rem;
    }

    .timeline-viewport__periods {
      display: flex;
      height: 100%;
    }

    .timeline-viewport__axis--vertical {
      display: none;
    }

    .timeline-viewport__axis--horizontal {
      display: block;
      right: 0;
      left: 0;
      top: var(--timeline-axis-position);
      height: 2px;
      transform: translateY(-50%);
    }
  }

  @media (min-width: 1400px) {
    .timeline-viewport {
      --timeline-track-height: 700px;
      --timeline-period-width: 270px;
      --timeline-card-width: 360px;
      --timeline-card-height: 270px;
    }
  }
</style>
